import type { Theme, Modifiers } from './types';
import { MODIFIER_SEPARATOR, CSS_PREFIX } from './constants';

type ThemeWithIndexKey = Theme & {
  [index: string]: string | boolean | number; // to support theme[key] in cns util
};

export default (theme: Theme) =>
  Object.keys(theme).reduce((obj: Modifiers, key: string) => {
    const value = (theme as ThemeWithIndexKey)[key];

    if (typeof value === 'string' || typeof value === 'number') {
      obj[[CSS_PREFIX, key, value].join(MODIFIER_SEPARATOR)] = true;
    } else {
      obj[[CSS_PREFIX, key].join(MODIFIER_SEPARATOR)] = value;
    }

    return obj;
  }, {});
